import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Steps } from 'antd';
import { DateTimeFormat } from '../../components/FormattersTS';
const VehicleHireStatusSteps = ({ vehicleHire }) => {
    const statuses = ['WITHHELD', 'ON_MARKET', 'ALLOCATED', 'STARTED', 'COMPLETED', 'CANCELLED'];
    return (_jsx("div", { children: (vehicleHire.status === 'CANCELLED') ?
            _jsx(Steps, { size: "small", current: 0, status: "error", items: [{
                        title: 'Cancelled',
                        content: _jsxs(_Fragment, { children: ["at ", _jsx(DateTimeFormat, { value: vehicleHire.cancelledAt })] })
                    }
                ] })
            :
                _jsx(Steps, { size: "small", current: statuses.indexOf(vehicleHire.status), status: vehicleHire.status === 'COMPLETED' ? 'finish' : 'process', items: [{
                            title: 'Withheld',
                            content: _jsx(DateTimeFormat, { value: vehicleHire.createdAt })
                        }, {
                            title: 'Posted'
                        }, {
                            title: 'Allocated',
                            content: vehicleHire.allocatedVehicle && _jsxs(_Fragment, { children: ["to ", vehicleHire.allocatedVehicle.registration, _jsx("br", {}), "at ", _jsx(DateTimeFormat, { value: vehicleHire.allocatedAt })] })
                        }, {
                            title: 'Started',
                            content: _jsxs(_Fragment, { children: ["at ", _jsx(DateTimeFormat, { value: vehicleHire.startedAt })] })
                        }, {
                            title: 'Completed',
                            content: _jsxs(_Fragment, { children: ["at ", _jsx(DateTimeFormat, { value: vehicleHire.completedAt })] })
                        }
                    ] }) }));
};
export default VehicleHireStatusSteps;
